import heartRed from "../assets/images/heart-red.webp";
import heartNeutral from "../assets/images/heart-neutral.webp";
import BackgroundImage from "../../../components/ui/BackgroundImage";
import bgImage from "../assets/images/bg.webp";

interface Props {
  className?: string;
  progress: number;
  variant: "fail" | "success";
}
const ProgressBar = ({ className = "", progress, variant }: Props) => {
  return (
    <BackgroundImage
      imageSrc={bgImage}
      imageClassName="rounded-xl"
      className={`relative rounded-xl h-full min-w-[100px] flex items-center justify-center ${className}`}
    >
      <img
        alt="heart"
        className="w-[38px]"
        src={variant === "fail" ? heartRed : heartNeutral}
      />
      <div className="absolute bottom-0 left-0 w-full h-full overflow-hidden rounded-xl flex justify-end items-end">
        <div
          className={`transition-all duration-500 ease-in-out bg-gradient-to-t ${
            variant === "fail"
              ? "from-[#992224]/20 to-[#FF393C]/30"
              : "from-[#69992F]/20 to-[#8cff00]/30"
          }`}
          style={{
            height: `${progress}%`,
            width: "100%",
          }}
        />
      </div>
    </BackgroundImage>
  );
};

export default ProgressBar;
